// tire: {
//   needPictures: false,
//   resourceKey: 'cars-tire',
//   keyList: [],
// },
export default {
  cars: {
    tire: {
      needPictures: false,
      resourceKey: 'cars-tire',
      keyList: [
        'brand',
        'model',
        'sub_model',
        'year',
        'tire_spec_width',
        'tire_spec_height',
        'tire_spec_diameter',
      ],
    },
    brake: {
      needPictures: false,
      resourceKey: 'cars-brake',
      keyList: ['brand', 'model', 'sub_model', 'year', 'prod_code'],
    },
    shock: {
      needPictures: false,
      resourceKey: 'cars-shock',
      keyList: ['brand', 'model', 'sub_model', 'year', 'prod_code'],
    },
    battery: {
      needPictures: false,
      resourceKey: 'cars-battery',
      keyList: ['brand', 'model', 'batt_amp', 'batt_type', 'batt_car_type', 'prod_code'],
    },
  },
  brands: {
    'brand-tire': {
      needPictures: true,
      imageKey: [
        {
          logo: 'image',
        },
      ],
      resourceKey: 'brand-tire',
      keyList: ['prod_brand_code', 'title_en', 'title_th'],
    },
    'brand-brake': {
      needPictures: true,
      imageKey: [
        {
          logo: 'image',
        },
      ],
      resourceKey: 'brand-brake',
      keyList: ['prod_brand_code', 'title_en', 'title_th'],
    },
    'brand-battery': {
      needPictures: true,
      imageKey: [
        {
          logo: 'image',
        },
      ],
      resourceKey: 'brand-battery',
      keyList: ['prod_brand_code', 'title_en', 'title_th'],
    },
    'brand-shock': {
      needPictures: true,
      imageKey: [
        {
          logo: 'image',
        },
      ],
      resourceKey: 'brand-shock',
      keyList: ['prod_brand_code', 'title_en', 'title_th'],
    },
    'brand-lubricant': {
      needPictures: true,
      imageKey: [
        {
          logo: 'image',
        },
      ],
      resourceKey: 'brand-lubricant',
      keyList: ['prod_brand_code', 'title_en', 'title_th'],
    },
    'brand-other': {
      needPictures: true,
      imageKey: [
        {
          logo: 'image',
        },
      ],
      resourceKey: 'brand-other',
      keyList: ['prod_brand_code', 'title_en', 'title_th'],
    },
  },
}
